// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3k8Uv","options":"AnswerScale_options__jf6Qn","selected":"AnswerScale_selected__342H6"};